<template>
  <div class="mdc-card mdc-elevation--z3 my-learn-card">
    <!-- {{ degree }} -->
    <div
      class="mdc-card__primary-action"
      tabindex="0"
      @click="moveLearnView(degree)"
      :id="`myDegreeCard${degree.id}`"
    >
      <div
        class="mdc-card__media mdc-card__media--16-9"
        :style="
          degree.thumbnail
            ? `background-image: url(${degree.thumbnail});`
            : 'background-image: url(https://s3-ap-northeast-1.amazonaws.com/clpintergrateuploadcontents/_kmath/thumnail.jpg);'
        "
        v-if="degree.thumbnail"
      >
        <div class="t-helper card-chip1 pdt-5 pdb-5 pdr-10 pdl-10">
          {{
            degree.lessonCount > 1
              ? $t("69", { str: degree.lessonCount })
              : $t("69", { str: degree.lessonCount })
          }}
          <!-- 5개 강의 -->
        </div>
        <div
          class="progressbar"
          :style="`width:${degree.progressRate}%;`"
        ></div>
      </div>
      <div class="pdt-14 pdl-16 pdr-16 pdb-19">
        <div class="t-body4 t-color-content1" v-if="!degree.thumbnail">
          {{ degree.category.text
          }}{{
            degree.category.child ? " > " + degree.category.child.text : ""
          }}
        </div>
        <div class="t-subtitle2 t-line-2">
          {{ degree.name }}
        </div>
        <div class="mgt-7">
          <div class="t-body3 t-color-content1" v-if="!degree.thumbnail">
            {{
              degree.lessonCount > 1
                ? $t("69", { str: degree.lessonCount })
                : $t("69", { str: degree.lessonCount })
            }}
            <!-- 5개 강의 -->
          </div>
          <div class="t-body3" v-if="degree.levels">
            <span
              class="t-color-content1"
              v-for="(level, index) in degree.levels"
              :key="index"
            >
              {{ level.text }}
              {{ degree.levels.length === index + 1 ? "" : "/" }}
            </span>
            <span class="t-body2 registrationDate">{{
              $moment(degree.periodRegister.start).format("L")
            }}</span>
          </div>

          <div class="t-body2" v-if="degree.teacher">
            {{ $t("70") }}
            <!-- by  -->
            {{ degree.teacher.name ? degree.teacher.name.fullName : $t("S10082") }}
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center pdb-8">
      <div class="flex-1 pdr-16 pdl-16" v-if="!degree.status">
        <span class="t-headline3">{{
          degree.progressRate ? degree.progressRate : "0"
        }}</span>
        <span class="t-subtitle1">%</span>
      </div>
      <div class="flex-1 pdr-16 pdl-16" v-else>
        <span class="t-subtitle1">
          {{ $t("77", { str: $moment(degree.startDate).format("L") }) }}
        </span>
      </div>
      <div>
        <button
          class="
            mdc-icon-button
            material-icons
            mdc-card__action mdc-card__action--icon--unbounded
            degree-card-more-button
          "
          @click="toggleProgress(degree.id)"
          :id="`myDegreeMore${degree.id}`"
        >
          {{ degree.progressViewStatus ? "expand_less" : "expand_more" }}
        </button>
      </div>
    </div>

    <component
      :is="`ListItemProgress`"
      class="recommand-degree-list"
      :degreeId="degree.id"
      :learnProgressRate="learnProgressRate"
      v-if="degree.progressViewStatus"
    ></component>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import learnApi from "@/api/learnApi.js";

export default {
  props: ["degree", "status"],
  data() {
    return {
      learnProgressRate: {},
    };
  },

  components: {
    ListItemProgress: () => import("@/components/learn/ListItemProgress.vue"),
  },

  mounted() {
    const selectorCard = `#myDegreeCard${this.degree.id}`;
    const ripplesCard = [].map.call(
      document.querySelectorAll(selectorCard),
      function (el) {
        return new MDCRipple(el);
      }
    );

    const selectorButton = `#myDegreeMore${this.degree.id}`;
    const ripplesButton = [].map.call(
      document.querySelectorAll(selectorButton),
      function (el) {
        let button = new MDCRipple.attachTo(el);
        button.unbounded = true;
        return button;
      }
    );
  },
  watch: {
    $route(to, from) {},
  },
  computed: {},
  methods: {
    // 학습진행율 데이터 (get learning status data)
    toggleProgress(id) {
      learnApi
        .learnProgressRate({ id: id })
        .then((response) => {
          this.learnProgressRate = response.data.data;
          console.log(this.learnProgressRate);
          this.$emit("initProgressStatus", id);
        })
        .catch((err) => {});
    },

    // move learn view
    moveLearnView(degree) {
      this.$route.query.searched = null; // stop refreshing in beforeEach in index.js

      if (degree.learning) {
        this.$router.push({
          name: "LearnView",
          query: this.$route.query,
          params: { learnId: degree.id },
        });
      } else {
        this.$alert({
          title: this.$t("72"), // 학습을 중단한 강의입니다.
          content: this.$t("73"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
          accept: this.$t("74"), // 확인
        })
          .then(() => {})
          .catch(() => {});
      }
      // this.$router.push({
      //         name: 'LearnView',
      //         query: this.$route.query,
      //         params: {learnId: degree.id}
      //     })
    },
  },
};
</script>